export default function ShinyText({ text, disabled = false, speed = 5, className = '' }) {
  return (
    <span
      className={`rb-shiny ${disabled ? 'rb-shiny--off' : ''} ${className}`}
      style={{ animationDuration: `${speed}s` }}
    >
      {text}
    </span>
  );
}
